/*
  A common service layer for completion commands (kompletteringar).
  Currently used by Ombudsansökan & Statsbidrag.
*/

import { ResponseError } from 'sos-common/js/utils/ResponseError';
import { doPatch } from './fetch.service';

/*
  Finish the completion with all posted files.
*/
export function sendCompletion(apiEndpoint: string, formData: FormData): Promise<boolean | ResponseError> {
  return doPatch<string>(apiEndpoint, formData).then((response) => {
    if (response instanceof ResponseError) return response;
    return true;
  });
}
